import { InputNumber } from "antd";
import { useState } from "react";
import styled from "styled-components";
import ClearIcon from "./ClearIcon";
import { CustomFieldTypes } from "./type";
import { toNumber } from "lodash";

interface TextEditorCellProps {
  currencySymbol?: string;
  onChange?: (value?: string | number | null) => void;
  value?: CustomFieldTypes;
  precision?: number;
  style?: React.CSSProperties;
  hanldeSubmit?: () => void;
  allowNull?: boolean;
  handleClear?: () => void;
  isEditable?: boolean;
}

const t = {
  placeHolder: "Enter number",
};

const InputWrapper = styled.div<{ hasControls: boolean }>`
  position: relative;
  width: 100%;

  .clear-button {
    position: absolute;
    right: ${(props) =>
      props.hasControls ? "32px" : "8px"}; /* Position based on controls */
    top: 50%;
    transform: translateY(-50%);
    pointer-events: auto;
    opacity: 0;
    transition: opacity 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
  }

  &:hover .clear-button {
    opacity: 1;
  }

  /* Ensure the input number component doesn't get affected by the clear button */
  .ant-input-number-handler-wrap {
    z-index: 1;
  }
`;

export default function NumericEditorCell(props: TextEditorCellProps) {
  const { allowNull = false } = props;
  const initialValue =
  props.value === "-" || isNaN(toNumber(props.value))
    ? undefined
    : toNumber(props.value);

  const [inputValue, setInputValue] = useState(initialValue);

  const inputStyle = props.style;

  // Handle input change
  const handleInputChange = (value: number | null) => {
    // If allowNull is true, we accept null/falsy values
    if (allowNull) {
      setInputValue(value as number);
      props?.onChange?.(value as number);
      return;
    }

    if (!value) {
      setInputValue(value as number);
    }

    if (value) {
      setInputValue(value);
    }

    props?.onChange?.(value);
  };

  const handleClear = (e: React.MouseEvent) => {
    if (e) {
      e.stopPropagation();
      e.preventDefault();
    }

    setInputValue(undefined);
    props?.onChange?.();
    props?.handleClear?.();
  };

  return (
    <InputWrapper hasControls={false}>
      <InputNumber
        prefix={props.currencySymbol}
        onChange={handleInputChange}
        type="number"
        placeholder={t.placeHolder}
        controls={false}
        style={{ width: "100%", ...inputStyle }}
        precision={props.precision}
        defaultValue={inputValue}
        disabled={!props.isEditable}
      />
      {props.isEditable && inputValue ? (
        <div className="clear-button">
          <ClearIcon onClick={handleClear} />
        </div>
      ) : null}
    </InputWrapper>
  );
}
